export default "__VITE_ASSET__ea57dcb7__"